import { List,Record } from "immutable";

import lineStyles from "../../../../constants/lineStyles";
import createFromJS from "../../../createFromJS";
import { PointRecord } from "../../helper/PointRecord";

export const MindmapConnectorDisplayRecord = Record({
  id: null,
  color: "mono",
  lineStyle: lineStyles.SOLID,
  points: List(),
  labelCenter: PointRecord(),
  label: null,
  subjectId: null,
  itemId: null,
  selected: false,
  overlap: false,
  isFiltered: false
});

const data = {
  objects: {
    points: "List",
    center: "PointRecord"
  }
};
createFromJS.registerCallback(
  "MindmapConnectorDisplayRecord",
  createFromJS.createNestedCallback(MindmapConnectorDisplayRecord, data)
);
